import React, { useState } from 'react';
import { initWebLogger, radar } from '@/common/log';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { RootSiblingParent } from 'react-native-root-siblings';
import { setGolbalConfig, setPageProps } from '@kibt/krn-utils';
import { useConstructor } from './hooks/useLifecycle';
import { Platform } from 'react-native';
import { parseUrl } from '@/common/utils/parseUrl';
import './common/init-request';
import { setAppProps } from './Navigation';
import { isWeb } from './common/device-info';
import { checkNativeNavbar } from './common/checkNativeBavbar';

export function CreateMpaPage(params: {
    app: any;
    rootTag?: number;
    safeArea: boolean;
    autoPvPageMap?: (args?: { page: string; params: any }) =>
        | boolean
        | {
              page: string;
              params?: any;
              contentPackage?: any;
          };
}) {
    const rootTag = params?.rootTag;
    return () => (props) => {
        const { app: App, autoPvPageMap, safeArea = true } = params;

        const [allProps, setAllProps] = useState(props);

        useConstructor(() => {
            isWeb && checkNativeNavbar();
            setGolbalConfig({ rootTag: rootTag ?? props.rootTag });
            let _allProps: object = {};
            //  从krnUri和degradeWebUrl中解析更多的参数
            if (Platform.OS !== 'web') {
                let krnUriParams = {};
                let degradeWebUrlParams = {};
                if (props.krnUri) {
                    krnUriParams = parseUrl(decodeURIComponent(props.krnUri));
                }
                // degradeWebUrl为krn打开失败降级的h5地址，所以这个一定能解析到h5中的参数，并且这个参数肯定不为空，android、ios双端必须要有这个参数
                if (props.degradeWebUrl) {
                    degradeWebUrlParams = parseUrl(decodeURIComponent(props.degradeWebUrl));
                }
                _allProps = { ...krnUriParams, ...degradeWebUrlParams, ...props, ...(rootTag ? { rootTag } : {}) };
                setPageProps(_allProps);
                setAllProps(_allProps);
                setAppProps(_allProps);
                console.log('allProps', JSON.stringify(_allProps, null, '  '));
            } else {
                setPageProps(props);
            }
            initWebLogger(props, {
                pageMap: autoPvPageMap,
            });
            radar.event({
                name: 'Shop_Krn_Load',
                params: _allProps,
            });
            const isRtl = false;
            if (Platform.OS === 'web') {
                document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
            }
        });

        if (!safeArea) {
            return <App {...allProps} />;
        }

        return (
            // 用absolute代替fixed 需要使用 RootSiblingParent
            // https://github.com/magicismight/react-native-root-siblings
            <RootSiblingParent>
                <SafeAreaProvider>
                    <App {...allProps} />
                </SafeAreaProvider>
            </RootSiblingParent>
        );
    };
}
